import { render, staticRenderFns } from "./GtsDocumentViewer.vue?vue&type=template&id=4a6f1e42&scoped=true"
import script from "./GtsDocumentViewer.vue?vue&type=script&lang=js"
export * from "./GtsDocumentViewer.vue?vue&type=script&lang=js"
import style0 from "./GtsDocumentViewer.vue?vue&type=style&index=0&id=4a6f1e42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6f1e42",
  null
  
)

export default component.exports